<template>
    <a
        href="#"
        @click.prevent="emitClick"
        :class="['secondary-pill-button', colour, { 'secondary-pill-button-disabled': disabled}]"
    >
        <slot />
    </a>
</template>

<script>
export default {
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        colour: {
            type: String,
            default: 'blue'
        }
    },
    methods: {
        emitClick() {
            if (!this.disabled) {
                this.$emit('click')
            }
        }
    }
}
</script>

<style lang="scss" scoped>

.secondary-pill-button {
    font-weight: bold;
    background: #2196f32e;
    padding: 0.25rem 1rem;
    border-radius: 15px;
    color: #2196f3;
    font-size: 14.5px;

    &:hover {
        background: darken(#2196f32e, 10%);
        text-decoration: none;
    }

    &.red {
        background: rgba(243, 33, 33, 0.18);
        color: #f32121;

        &:hover {
            background: darken(rgba(243, 33, 33, 0.18), 10%);
        }
    }

    &.secondary-pill-button-disabled {
        background: #e0e0e0;
        color: #999;

        &:hover {
            background: #e0e0e0;
        }
    }
}

</style>